import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
var boxClasses = generateUtilityClasses('MuiBox', ['root']);
export default boxClasses;